import { Controller } from "@hotwired/stimulus"

/**
 * The full-width header (layouts/_navbar): plain paper at the top of the page, a hairline and a soft
 * shadow (.is-scrolled) once the page scrolls.
 */
export default class extends Controller<HTMLElement> {
  private frame = 0

  connect() {
    this.update()
    window.addEventListener("scroll", this.onScroll, { passive: true })
  }

  disconnect() {
    window.removeEventListener("scroll", this.onScroll)
    cancelAnimationFrame(this.frame)
  }

  private onScroll = () => {
    cancelAnimationFrame(this.frame)
    this.frame = requestAnimationFrame(() => this.update())
  }

  private update() {
    this.element.classList.toggle("is-scrolled", window.scrollY > 8)
  }
}
